import angular from 'angular';
import SessionService from './session.service';

let sessionModule  = angular.module('shared.components.session', [])
  .service('SessionService', SessionService);

export default sessionModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/session/session.js
 **/